<template>
  <div class="home">
    <Landing />
  </div>
</template>

<script>
// @ is an alias to /src
import Landing from '@/components/Landing.vue'

export default {
  name: 'Home',
  components: {
    Landing,
  },
  mounted() {
    document.title = 'IM App下载'

    const scheme = {
      '1682d3a2ee0c4ee8acbe58a5c39bb888':'A01',    //A01
      'PcTfdNK4EdJvxLpbvoV8Kn2798OrtxE2':"A02",    //A02
      'PCHas53duTI4rGn45WSWRM2Dnv0XWvxc':"A04",    //A04
      'TdmLxxLAMxkVG7JFJ5S5I5EfZI49qS2X':"A05",    //A05
      'd0670969d3e5403d906e21f1a4e77913':"E04",    //E04
      'a80db5262e14467b82d6dec666073364':"H86",    //H86
      'f11230926baf45578f2b77c9579d8275':"HX1",    //HX1
      'a6ydgchQ0gGY5NTGd70uMg3jR9wfgQBi':"C08",    //C08
    }
    const productId = this.$route.query.productId
    if(productId && scheme[productId]){
      let icon = scheme[productId]
      document.querySelector('link[rel=icon]').href= `logo_${icon}.ico` 
    }
  },
}
</script>
